import Indicator from '../Indicator';

/** Sector Industry indicator */
export default class SectorIndustryIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs - Make sure to pass in a
	 * valid cusip as part of your args.params.inputs when creating a sector
	 * industry indicator
	 * @property {object[]} componentSeries - Indicator component series
	 * @property {number} valueMultiplier - Indicator value multiplier. Used to
	 * normalize percent values depending on data - 1 or 100
	 */
	_getDefaultParams() {
		return {
			id: 'sectorindustry',
			name: 'Sector & Industry',
			description: 'The Sector/Industry chart indicator enables a comparative analysis between a company\'s stock performance and that of a broader sector or industry symbol.',
			inputs: [
				{ name: 'cusip', value: 'INVALIDCUSIP' } // note: pass valid cusip when creating indicator
			],
			componentSeries: [{ id: 'sectorindustry' }],
			valueMultiplier: 1
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
